/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import CrossSellUpSell from './planSubscription/crossSellUpSell';
import SubscriptionStatus from './planSubscription/subscriptionStatus';
import { StatusMapping } from './planSubscription/subscriptionStatus';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';

class PlanSubscription extends Component<WithI18nProps> {
  render() {
    let { subscription = {}, tenantApp } = this.props;
    const isFreemium = isFreemiumPlan(tenantApp);

    // Get subscription status
    const { status } = subscription;
    const originStatus = StatusMapping[status];

    return (
      <div className="BC-PlanSubscription__DashboardV3">
        <Card sectioned>
          <SubscriptionStatus />
          {originStatus !== 'trial' && !isFreemium && <CrossSellUpSell />}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    features: _.get(state.dashboardV3, 'features', {}),
    gettingFeatures: _.get(state.dashboardV3, 'gettingFeatures', {}),
    subscription: _.get(state.oauth, 'subscription', {})
  };
};

export default connect(mapStateToProps, null)(withI18n()(PlanSubscription));
